export function ProcessSpectrum(spectrum, options) {
    let newSpectrum = spectrum.slice();

    newSpectrum = maxShift(newSpectrum, options.maxShiftPasses);
    if (options.smoothed)
        newSpectrum = smooth(newSpectrum, options.smoothingPasses, options.smoothingPoints, options.loop);
    if (options.barCount)
        newSpectrum = conformToBarCount(newSpectrum, options.barCount);

    return newSpectrum;
}

export function GetSpectrumMagnitude(spectrum) {
    const spectrumSum = spectrum.reduce((a, b) => a + b, 0);
    return spectrumSum / spectrum.length;
}

// Doubles the number of frames by performing linear interpolation between consecutive frames.
// For each pair of adjacent frames in the input array, this function creates a new intermediate frame
// by averaging the values between them, effectively doubling the frame rate.
export function DoubleFrames(inputFrames) {
    var interpolatedFrames = [];
    
    if (!inputFrames || !inputFrames.length)
        return interpolatedFrames;

    for (var i = 0; i < inputFrames.length; i++) {
        const currentFrame = inputFrames[i];
        const nextFrame = inputFrames[i + 1];

        if (!nextFrame) {
            interpolatedFrames.push(currentFrame);
            interpolatedFrames.push(currentFrame);
            break;
        }

        const middleFrame = [];
        for (var j = 0; j < currentFrame.length; j++) {
            middleFrame.push((currentFrame[j] + nextFrame[j]) / 2);
        }

        interpolatedFrames.push(currentFrame);
        interpolatedFrames.push(middleFrame);
    }

    return interpolatedFrames;
}

//increase values toward the max values
function maxShift(array, maxShiftPasses) {
    var newArr = array.slice();
    var length = newArr.length
    for (var i = 0; i < maxShiftPasses; i++) {
        newArr = conformToBarCount(newArr, length * 2 + 1);
        newArr = conformToBarCountMax(newArr, length);
    }
    return newArr;
}

function conformToBarCount(array, target) {
    var newArr = [];

    var multiplier = (array.length - 1) / (target - 1);
    for (var i = 0; i < target - 1; i++) {
        var point = i * multiplier;
        var part1 = array[Math.floor(point)] * Math.abs(point % 1 - 1);
        var part2 = array[Math.ceil(point)] * (point % 1);
        newArr.push(part1 + part2);
    }

    newArr.push(array[array.length - 1]);

    return newArr;
}

function conformToBarCountMax(array, target) {
    var newArr = [];

    var multiplier = (array.length - 1) / (target - 1);
    for (var i = 0; i < target - 1; i++) {
        var point = i * multiplier;
        newArr.push(Math.max(array[Math.floor(point)], array[Math.ceil(point)]));
    }

    newArr.push(array[array.length - 1]);

    return newArr;
}

/*
New BSD License (BSD-new)

Copyright (c) 2015 Maxim Roncacé
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:
    - Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    - Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.
    - Neither the name of the copyright holder nor the names of its contributors
      may be used to endorse or promote products derived from this software
      without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

function smooth(array, smoothingPasses, smoothingPoints, loop = true) {
    var lastArray = array;
    for (var pass = 0; pass < smoothingPasses; pass++) {
        var sidePoints = Math.floor(smoothingPoints / 2);
        var cn = 1 / (2 * sidePoints + 1);
        var newArr = [];
        var i;
        for (i = 0; i < lastArray.length; i++) {
            var sum = 0;
            for (var n = -sidePoints; n <= sidePoints; n++) {
                if (i + n >= lastArray.length) {
                    sum += loop ? cn * lastArray[n - 1] : cn * lastArray[i];
                } else if (i + n < 0) {
                    sum += loop ? cn * lastArray[lastArray.length + n] : cn * lastArray[i];
                } else {
                    sum += cn * lastArray[i + n];
                }
            }
            newArr[i] = sum;
        }
        lastArray = newArr;
    }
    return newArr;
}